﻿import debounce from "./debounce.js";
import delay from "./delay.js";
import downloadFileStream from "./downloadFileStream.js";
import findClosestScrollContainer from "./findClosestScrollContainer.js";
import focus from "./focus.js";
import focusPreviousFocusableElement from "./focusPreviousFocusableElement.js";
import isElementInView from "./isElementInView.js";
import openFileInNewTab from "./openFileInNewTab.js";
import printHtmlInNewWindow from "./printHtmlInNewWindow.js";
import scrollToId from "./scrollToId.js";
import setTitle from "./setTitle.js";
import {setValue} from "../alpine/utlities/value.js";

export default {
  debounce,
  delay,
  downloadFileStream,
  findClosestScrollContainer,
  focus,
  focusPreviousFocusableElement,
  isElementInView,
  openFileInNewTab,
  printHtmlInNewWindow,
  scrollToId,
  setTitle,
  setValue,
};
